export const collator = new Intl.Collator('sv');
